/**
 * Sortierungen der Kartensuche — eine Liste für Sammlung, Editor-Katalog und mobile Suche,
 * weil alle dieselben Werte an die Backend-Whitelists schicken (`GET /api/cards/search` und
 * die Sammlungs-Suche kennen beide jeden Wert hier, auch den EDHREC-Rang).
 *
 * `naturalDirection` gehört dazu: Richtung ist ein eigener Wert, und ohne diese Zuordnung
 * stünde die Liste nach dem Wechsel von „Erscheinungsdatum" auf „Name" bei Z→A.
 */
export const CARD_SORT_OPTIONS = [
  { value: 'released', label: 'Erscheinungsdatum' },
  { value: 'name', label: 'Name' },
  { value: 'price', label: 'Preis' },
  { value: 'cmc', label: 'Kosten' },
  { value: 'power', label: 'Stärke' },
  { value: 'toughness', label: 'Widerstand' },
  { value: 'rarity', label: 'Seltenheit' },
  // Aufsteigend = beliebteste zuerst (niedriger Rang = beliebter)
  { value: 'edhrec', label: 'EDHREC-Rang' },
];

// Die Feldnamen sind die der API (`sortOption`/`sortDirection`) — die Sammlung führt ihren
// Zustand als `sortField`/`sortDirection`, die mobile Suche als `sortOption`/`sortDirection`;
// ein dritter Namenssatz hier hätte an jeder Aufrufstelle eine Umbenennung erzwungen.
export const DEFAULT_SORT = { sortOption: 'released', sortDirection: 'desc' };

export function naturalDirection(value) {
  return value === 'released' ? 'desc' : 'asc';
}
